/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const TEST_ID = 'search-filter-menu';
